module.exports = __webpack_public_path__ + "ca155b7c86a6a769c6c85d8854b08dbb.png";